import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { ContingencyPCSService } from 'src/app/service/pcs/contingency-pcs.service';

@Component({
  selector: 'app-add-contingency-dialog',
  templateUrl: './add-contingency-dialog.component.html',
  styleUrls: ['./add-contingency-dialog.component.scss'],
  standalone: false
})
export class AddContingencyDialogComponent implements OnInit {
  heading: string;
  eventType: string;
  periodID: number;
  errormsg: string;

  contProdList = []
  doubleshipDateList = []
  selectedcontprodDateId;
  selectedcontprodDateValue
  selecteddoubleshipDateId
  selecteddoubleshipDateValue
  plantList = []
  selectedPlant: string;
  selectedPlantId;
  domicileList = []
  selectedDomicile: string;
  selectedDomicileId;
  routeList = []
  selectedRoute: string;
  selectedRouteId
  dockList = []
  selectedDockId;
  selectedDockValue
  orderSequenceList = []
  selectedOrderSequence: string;
  DSRequestNeededYNList = []
  selectedDSRequestNeededYNId;
  DSWithoutRequestYNList = []
  selectedDSWithoutRequestYNId;
  selectedNASupplierCode
  selectedEvaluationComment = ""
  selectedVolumeM3: any = "0.00"
  selectedMiles: any = "0.00"
  lmList = []
  lmId = "INCOMPLETE";
  diagramList = []
  diagramId = "INCOMPLETE";;
  sketchList = []
  sketchId = "INCOMPLETE";;
  toggleLM
  toggleDiagram
  toggleSketch
  selectedComment = ""
  contDoubleMasterList = []
  domicileRouteMasterList = []
  tempPlantDockList = []
  constructor(public dialogRef: MatDialogRef<AddContingencyDialogComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly constants: Constants,
    private readonly ngxUiLoaderService : NgxUiLoaderService, private readonly contingencyPCSService : ContingencyPCSService) { }

  ngOnInit(): void {

    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    this.periodID = this.dataStore.periodID
    this.contDoubleMasterList = this.dataStore.contDoubleMasterList
    this.domicileRouteMasterList = this.dataStore.domicileRouteMasterList
    this.tempPlantDockList = this.dataStore.plantDockList
    this.tempPlantDockList.forEach((obj, index) => {
      if (obj.plant != null)  // NOSONAR
        {this.plantList.push({ id: index + 1, value: obj.plant })}
    })
    this.plantList = [... new Map(this.plantList.map(x => [x['value'], x])).values()];
    console.info(this.plantList)
    this.lmList = this.sketchList = this.diagramList = this.dataStore.lmDiagramSketch
    this.DSRequestNeededYNList = this.dataStore.dsReqNeedList
    this.DSWithoutRequestYNList = this.dataStore.dsWithoutReqSuppliers
    this.contDoubleMasterList.forEach((obj, index) => {
      if (obj.contprodDate != null)  // NOSONAR
        {this.contProdList.push({ id: index + 1, value: obj.contprodDate })}
    })
    this.contProdList.sort((a, b) => (a.value > b.value ? -1 : 1))
    this.domicileRouteMasterList.forEach((obj, index) => {
      if (obj.domicile != null)  // NOSONAR
       { this.domicileList.push({ id: index + 1, value: obj.domicile })}
    })
    this.domicileList = [... new Map(this.domicileList.map(x => [x['value'], x])).values()];
    this.domicileList.sort((a, b) => (a.value > b.value ? 1 : -1))

  }
  onDropDownChange(module) {
    if (module == 'contproddate') { // NOSONAR
      this.doubleshipDateList = []
      this.selectedcontprodDateValue = this.contProdList.find(x => x.id == this.selectedcontprodDateId).value // NOSONAR
      const tempDoubleShipDate = this.contDoubleMasterList.filter(x => x.contprodDate == this.selectedcontprodDateValue)  // NOSONAR
      if (tempDoubleShipDate) {
        tempDoubleShipDate?.forEach((obj, index) => {
          if (obj.doubleshipDate != null) // NOSONAR
          {
            this.doubleshipDateList.push({ id: index + 1, value: obj.doubleshipDate })
          }
        })
        this.doubleshipDateList.sort((a, b) => (a.value > b.value ? -1 : 1))
        this.selecteddoubleshipDateId = this.doubleshipDateList[0].id
      }
    } else if (module == 'domicile') { // NOSONAR
      this.routeList = []
      this.selectedDomicile = this.domicileList.find(x => x.id == this.selectedDomicileId).value // NOSONAR
      const tempDomicileRouteList = this.domicileRouteMasterList.filter(x => x.domicile == this.selectedDomicile) // NOSONAR
      if (tempDomicileRouteList) {
        tempDomicileRouteList?.forEach((obj, index) => {
          if (obj.route != null) // NOSONAR
          {
            this.routeList.push({ id: index + 1, value: obj.route })
          }

        })
        this.routeList.sort((a, b) => (a.value > b.value ? 1 : -1))
        this.selectedRouteId = this.routeList[0].id
      }
    } else if (module == 'plant') { // NOSONAR
      this.selectedPlant = this.plantList.find(x => x.id == this.selectedPlantId).value  // NOSONAR
      const tempCommonList = this.tempPlantDockList.filter(x => x.plant == this.selectedPlant)  // NOSONAR
      this.dockList = []
      if (tempCommonList.length > 0) {
        tempCommonList.forEach((obj, index) => {
          if (obj.dock != null) // NOSONAR
          {
            this.dockList.push({ id: index + 1, value: obj.dock })
          }
        })
        this.dockList = [... new Map(this.dockList.map(x => [x['value'], x])).values()];
        this.selectedDockId = null
      }
    }
  }
  keyPressAlphaNumeric(event, module) {
    if (module == 'nasuppliercode') {  // NOSONAR
      const inp = String.fromCharCode(event.keyCode);
      if (/[a-zA-Z0-9]/.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }
    return true
  }
  keyUpEvent(_event, module) {
    if (module == 'volumem3') { // NOSONAR
      

      const text = String(this.selectedVolumeM3)
      const arr = text.split(".")

      
      let leftSide, rightSide
      leftSide = arr[0]
      if (arr[0].length > 2) {
        leftSide = arr[0] = arr[0].substring(0, 2)
        this.selectedVolumeM3 = leftSide
      }
      if (arr[1] != undefined) { // NOSONAR
        rightSide = arr[1]
        if (arr[1].length > 1)
        {
          rightSide = arr[1] = arr[1].substring(0, 2)
        }
        this.selectedVolumeM3 = leftSide + "." + rightSide
      }
    } else if (module == 'milessaved') { // NOSONAR

      const text = String(this.selectedMiles)
      const arr = text.split(".")

      let rightSide
      const leftSide = arr[0]
      if (arr[1] != undefined) { // NOSONAR
        rightSide = arr[1]
        if (arr[1].length > 1)
          {rightSide = arr[1] = arr[1].substring(0, 2)}
        this.selectedMiles = leftSide + "." + rightSide
      }
    }
  }
  textUpdated(module) {
    if (module == 'volumem3') {  // NOSONAR
      if (!this.selectedVolumeM3) 
        {this.selectedVolumeM3 = 0;}
      this.selectedVolumeM3 = Number(this.selectedVolumeM3).toFixed(2)
    } else if (module == 'milessaved') {  // NOSONAR
      if (!this.selectedMiles) 
        {
          this.selectedMiles = 0;
        }
      this.selectedMiles = Number(this.selectedMiles).toFixed(2)
    }
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  public saveClick(): void {
    this.errormsg = '';

    if (this.hasValidationErrors()) {
      return;
    }

    this.populateSelectedValues();

    if (this.isDSRequestInvalid()) {
      this.showError(
        'Please complete LM, Diagram and Sketch Evaluation for DS Request to be Yes'
      );
      return;
    }

    const requestObject = this.buildRequestObject();

    if (this.eventType == 'ADD') {  // NOSONAR
      this.saveRequest(requestObject);
    }
  }


  showError(message) {
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = "";
    }, this.constants.notificationMessageTime);
  }

  isValueOk(param: any): boolean {

    if (param == undefined || param == null || param == "") {  // NOSONAR
      return true;
    }
    return false;
  }

  private hasValidationErrors(): boolean {
    if (this.isValueOk(this.periodID)) {
      this.showError('Please select Period');
      return true;
    }

    const invalid =
      this.isValueOk(this.selectedcontprodDateId) ||
      this.isValueOk(this.selecteddoubleshipDateId) ||
      this.isValueOk(this.selectedPlantId) ||
      this.isValueOk(this.selectedDomicileId) ||
      this.isValueOk(this.selectedRouteId);

    if (invalid) {
      this.showError(this.constants.formInputError);
    }

    return invalid;
  }

  private populateSelectedValues(): void {
    this.selectedcontprodDateValue =
      this.contProdList.find(x => x.id == this.selectedcontprodDateId)?.value;  // NOSONAR

    this.selecteddoubleshipDateValue =
      this.doubleshipDateList.find(x => x.id == this.selecteddoubleshipDateId)?.value;  // NOSONAR

    this.selectedPlant =
      this.plantList.find(x => x.id == this.selectedPlantId)?.value;  // NOSONAR

    this.selectedDomicile =
      this.domicileList.find(x => x.id == this.selectedDomicileId)?.value;  // NOSONAR

    this.selectedRoute =
      this.routeList.find(x => x.id == this.selectedRouteId)?.value;  // NOSONAR

    this.selectedDockValue =
      this.dockList.find(x => x.id == this.selectedDockId)?.value ?? null;  // NOSONAR

    this.selectedVolumeM3 = Number(this.selectedVolumeM3)?.toFixed(2);
    this.selectedMiles = Number(this.selectedMiles)?.toFixed(2);

    this.selectedEvaluationComment = this.selectedEvaluationComment?.trim();
    this.selectedComment = this.selectedComment?.trim();
  }

  private isDSRequestInvalid(): boolean {
    return ( this.selectedDSRequestNeededYNId == 'Y' && (this.lmId == 'INCOMPLETE' || this.diagramId == 'INCOMPLETE' || this.sketchId == 'INCOMPLETE') );  // NOSONAR
  }

  private buildRequestObject(): any {
    return {
      periodID: Number(this.periodID),
      contprodDate: this.selectedcontprodDateValue,
      doubleshipDate: this.selecteddoubleshipDateValue,
      plant: this.selectedPlant,
      domicile: this.selectedDomicile,
      route: this.selectedRoute,
      nasuppliercode: this.selectedNASupplierCode,
      dock: this.selectedDockValue,
      evaluation_comment: this.selectedEvaluationComment ?? null,
      volumeM3: Number(this.selectedVolumeM3),
      milesSaved: Number(this.selectedMiles),
      lm: this.lmId,
      diagram: this.diagramId,
      sketch: this.sketchId,
      dsReqNeeded: this.selectedDSRequestNeededYNId ?? null,
      dsWoReqSuppliers: this.selectedDSWithoutRequestYNId ?? null,
      comments: this.selectedComment ?? null
    };
  }

  private saveRequest(requestObject: any): void {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);

    this.contingencyPCSService.addContingencyPCS(requestObject).subscribe(
      response => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);

        if (response == 'Success') {   // NOSONAR
          this.dialogRef.close({
            event: 'SaveEvent',
            eventType: this.eventType,
            eventResult: response
          });
        } else {
          this.showError(this.constants.APIErrorMessage);
        }
      },
      () => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
        this.showError(this.constants.APIErrorMessage);
      }
    );
  }







}
